import React, { useEffect, useState } from 'react';
import { telegramAPI } from '../../utils/api';
import { getTelegramBotLink } from '../../utils/telegram';

const TelegramLinkModal: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [url, setUrl] = useState<string | null>(null);
  const [expiresAt, setExpiresAt] = useState<number | null>(null);
  const [remaining, setRemaining] = useState(0);
  useEffect(() => {
    if (expiresAt === null) return;
    const update = () => setRemaining(Math.max(0, Math.ceil((expiresAt - Date.now()) / 1000)));
    update();
    const timer = window.setInterval(update, 1000);
    return () => window.clearInterval(timer);
  }, [expiresAt]);
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => { if (event.key === 'Escape' && !loading) onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [loading, onClose]);
  const createLink = async () => {
    if (url && expiresAt !== null && expiresAt > Date.now()) {
      window.open(url, '_blank', 'noopener,noreferrer');
      return;
    }
    setLoading(true);
    setError('');
    setUrl(null);
    setExpiresAt(null);
    let botWindow: Window | null = null;
    try {
      // Открываем вкладку непосредственно по клику, пока браузер разрешает всплывающее окно.
      botWindow = window.open('about:blank', '_blank');
      if (botWindow) botWindow.opener = null;
      const response = await telegramAPI.createNotificationLink();
      if (!response.success) throw new Error(response.message || 'Не удалось получить ссылку на бота');
      const link = getTelegramBotLink(response.data);
      if (!link) throw new Error('Внешнее API не вернуло корректную ссылку на Telegram-бота');
      const ttl = response.data?.expires_in;
      if (typeof ttl !== 'number' || !Number.isFinite(ttl) || ttl <= 0) throw new Error('Внешнее API не вернуло срок действия ссылки');
      setUrl(link);
      setRemaining(Math.ceil(ttl));
      setExpiresAt(Date.now() + ttl * 1000);
      if (botWindow && !botWindow.closed) {
        botWindow.location.replace(link);
      } else {
        window.open(link, '_blank', 'noopener,noreferrer');
      }
    } catch (err) {
      if (botWindow && !botWindow.closed) botWindow.close();
      setError(err instanceof Error ? err.message : 'Ошибка получения ссылки');
    } finally { setLoading(false); }
  };
  return <div className="profile-modal" role="dialog" aria-modal="true" aria-labelledby="telegram-link-title">
    <div className="profile-modal__backdrop" onClick={() => !loading && onClose()} />
    <div className="profile-modal__dialog">
      <header className="profile-modal__header"><h2 className="profile-modal__title" id="telegram-link-title">Уведомления в Telegram</h2><button type="button" className="profile-modal__close" aria-label="Закрыть" disabled={loading} onClick={onClose}>×</button></header>
      <div className="profile-modal__body">
        <p className="tg-help">Нажмите «Подключить Telegram» — бот откроется автоматически. В Telegram нажмите «Старт», чтобы привязать аккаунт.</p>
        <div className="tg-connect">
          <button type="button" className="profile-modal__button profile-modal__button--primary" disabled={loading} onClick={() => void createLink()}>{loading ? 'Открываем Telegram…' : url ? remaining > 0 ? 'Открыть Telegram' : 'Получить новую ссылку' : 'Подключить Telegram'}</button>
          {url && <div className="tg-link-hint">{remaining > 0 ? <>Если бот не открылся автоматически, <a href={url} target="_blank" rel="noopener noreferrer">откройте Telegram</a>.<p>В Telegram нажмите «Старт» для завершения привязки.</p><p>Ссылка действует ещё {Math.floor(remaining / 60)} мин {remaining % 60} с.</p></> : <p>Срок действия ссылки истёк. Получите новую ссылку.</p>}</div>}
        </div>
        {error && <div className="profile-modal__error" role="alert">{error}</div>}
      </div>
      <footer className="profile-modal__footer"><button type="button" className="profile-modal__button profile-modal__button--secondary" disabled={loading} onClick={onClose}>Закрыть</button></footer>
    </div>
  </div>;
};
export default TelegramLinkModal;
